export enum SubscribeEndpointsEnum {
  SUBSCRIBE = "/newsletter",
}
